<ejs-tab #tabObj Selecting="Select" id="element" class="mt-2" [animation]="animation" heightAdjustMode="fill"
  (selecting)="select($event)" (created)="tabGroupCreated()">
  <e-tabitems>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.assets.product-assets.edit-asset.general' | translate}}
      </ng-template>
      <ng-template #content>
        <app-asset-upload-editor #assetUploadEditorComponent
                                [assetUploadEditorForm]="assetUploadEditorForm">
        </app-asset-upload-editor>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.assets.product-assets.edit-asset.edit-image' | translate}}
      </ng-template>
      <ng-template #content>
        <div class="row">
          <div class="col-12 mb-2">
            <button class="btn btn-primary me-2 btn-fixedw rounded right" type="button"
              (click)="toggleFullScreen()">
              <span class="e-icons icon-maximize"></span>
              {{ 'i18n.domain.assets.product-assets.edit-asset.toggle-full-screen' | translate }}
            </button>
          </div>
        </div>
        @if(showImageEditor && fileData !== null){
          <div class="row">
            <div class="col-12">
              <app-asset-image-editor #assetImageEditorComponent
                                      [fileData]="fileData"
                                      [fullScreen]="isFullScreen">
              </app-asset-image-editor>
            </div>
          </div>
        }
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>
